<template>
  <q-popover>
    <div class="row gutter-xs q-pa-md">
      <div class="col-auto column">
        <q-btn flat @click="handleToday">{{ $t('today') }}</q-btn>
        <q-btn flat @click="handleWeek" class="q-mt-sm">{{ $t('this_week' )}}</q-btn>
        <q-btn flat @click="handleLastWeek" class="q-mt-sm">{{ $t('last_week') }}</q-btn>
        <q-btn flat @click="handleMonth" class="q-mt-sm">{{ $t('this_month') }}</q-btn>
        <q-btn flat @click="handleLastMonth" class="q-mt-sm">{{ $t('last_month') }}</q-btn>
      </div>

      <div class="col">
        <date-picker
          ref="datePicker"
          :value="value"
          :locale="locale"
          :columns="2"
          mode="range"
          color="indigo"
          style="border: none"
          is-inline
          @input="handleInput"
        />
      </div>
    </div>
  </q-popover>
</template>

<script>
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'
  import endOfMonth from 'date-fns/end_of_month'
  import endOfWeek from 'date-fns/end_of_week'
  import { mapGetters } from 'vuex'
  import startOfDay from 'date-fns/start_of_day'
  import startOfMonth from 'date-fns/start_of_month'
  import startOfWeek from 'date-fns/start_of_week'
  import subMonths from 'date-fns/sub_months'
  import subWeeks from 'date-fns/sub_weeks'

  export default {
    components: {
      DatePicker
    },
    props: {
      value: {
        required: true
      }
    },
    computed: {
      ...mapGetters(['locale'])
    },
    methods: {
      handleInput ({ start, end }) {
        this.$emit('input', { start, end })
        this.$refs.datePicker.$refs.calendar.focusDate(start)
      },
      handleToday () {
        this.$emit('input', { start: startOfDay(new Date()), end: startOfDay(new Date()) })
        this.$refs.datePicker.$refs.calendar.focusDate(this.value.start)
      },
      handleWeek () {
        this.$emit('input', { start: startOfDay(startOfWeek(new Date(), { weekStartsOn: 1 })), end: startOfDay(new Date()) })
        this.$refs.datePicker.$refs.calendar.focusDate(this.value.start)
      },
      handleLastWeek () {
        const now = new Date()
        const startLastWeek = startOfDay(startOfWeek(subWeeks(now, 1), { weekStartsOn: 1 }))
        const endLastWeek = startOfDay(endOfWeek(startLastWeek, { weekStartsOn: 1 }))
        this.$emit('input', { start: startLastWeek, end: endLastWeek })
        this.$refs.datePicker.$refs.calendar.focusDate(this.value.start)
      },
      handleMonth () {
        this.$emit('input', { start: startOfDay(startOfMonth(new Date())), end: startOfDay(new Date()) })
        this.$refs.datePicker.$refs.calendar.focusDate(this.value.start)
      },
      handleLastMonth () {
        const now = new Date()
        const startLastMonth = startOfDay(startOfMonth(subMonths(now, 1)))
        const endLastMonth = startOfDay(endOfMonth(startLastMonth))
        this.$emit('input', { start: startLastMonth, end: endLastMonth })
        this.$refs.datePicker.$refs.calendar.focusDate(this.value.start)
      }
    }
  }
</script>

<style lang="stylus">
  // Fix name clash with Quasar
  .vc-day.on-left, .vc-day.on-right
    margin inherit !important
</style>
